// @ts-nocheck
// tslint:disable
import { HTMLMediaElement } from './HTMLMediaElement';

export class HTMLVideoElement extends HTMLMediaElement {
  constructor() {
    super('video');
  }
}
